import { Button } from "@fluentui/react-components";
import { NextFilled, PlayFilled, PreviousFilled } from "@fluentui/react-icons";
import * as React from "react";
import { useState } from "react";
import { RecResult } from "../../../client";
import { clearCellColors, highlightCells } from "../../taskpane";

interface ReviewActionProps {
  result: string | number | boolean | RecResult[];
  isDisabled: boolean;
}

const ReviewAction: React.FC<ReviewActionProps> = (props) => {
  const [resultIndex, setResultIndex] = useState<number>(-1);
  const [isPaused, setIsPaused] = useState<boolean>(false);

  const handleClick = async (direction) => {
    direction === "next" ? setResultIndex(resultIndex + 1) : setResultIndex(resultIndex - 1);
    // Highlight cells
    const results = props.result as RecResult[];
    const result = direction === "next" ? results[resultIndex + 1] : results[resultIndex - 1];
    const priorResult = results[resultIndex];
    const cellAddresses = result.cell_locs_reconciling;
    const priorCellAddresses = priorResult ? priorResult.cell_locs_reconciling : null;
    setIsPaused(true);
    if (priorCellAddresses) {
      await clearCellColors(priorCellAddresses);
    }
    if (cellAddresses) {
      await highlightCells(cellAddresses, "yellow");
    }
    setIsPaused(false);
  };

  return (
    <>
      <Button
        icon={<PreviousFilled />}
        disabled={props.isDisabled || resultIndex < 1 || isPaused}
        onClick={() => handleClick("prev")}
      >
        Previous
      </Button>
      <Button
        icon={resultIndex === -1 ? <PlayFilled /> : <NextFilled />}
        disabled={
          props.isDisabled || resultIndex >= (props.result as RecResult[]).length - 1 || isPaused
        }
        onClick={() => handleClick("next")}
      >
        {resultIndex === -1 ? "Start" : "Next"}
      </Button>
    </>
  );
};

export default ReviewAction;
